import { compose as o } from "../../tailwind-buddy-interface.js";
const t = o({
  slots: {
    // Resets TW base styles for `hr`
    root: (
      /** @tw */
      "border-none bg-[theme(borderColor[color-primary])]"
    )
  },
  variants: {
    /** Sets divider orientation. */
    orientation: {
      horizontal: (
        /** @tw */
        "h-012"
      ),
      // Resets height from TW base styles for `hr'
      vertical: (
        /** @tw */
        "w-012 h-auto"
      )
    }
  },
  defaultVariants: {
    orientation: "horizontal"
  },
  responsiveVariants: ["orientation"]
})();
export {
  t as dividerVariants
};
